import React, { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { BiExit, BiHome, BiSupport, BiUserPin } from "react-icons/bi";
import { BsCalendar2CheckFill } from "react-icons/bs";
import { Link, useLocation } from "react-router-dom";
import SupportCard from "../Components/Cards/Support";
import { MdAddToPhotos, MdLibraryAddCheck, MdPayment } from "react-icons/md";
import { now } from "../Utils/functions";
import { useMainContext } from "../Context";
import { IoBookmarks } from "react-icons/io5";
import { RiVipCrownFill } from "react-icons/ri";
const PanelLayout = ({ children }) => {
  const [show, setShow] = useState(false);
  const props = {
    size: "1.2re,",
  };
  const toggle = () => setShow(!show);
  const { pathname } = useLocation();
  const { logout } = useMainContext();
  useEffect(() => {
    if (!show) return;
    setShow(false);
  }, [pathname]);
  let links = [
    {
      label: "داشبورد",
      to: "/dashboard",
      icon: <BiHome {...props} />,
      title: "داشبورد",
    },

    {
      label: "حساب کاربری",
      to: "/profile",
      icon: <BiUserPin {...props} />,
      title: "حساب کاربری",
    },
    {
      label: "ثبت آگهی",
      to: "/ads-submit",
      icon: <MdAddToPhotos {...props} />,
      title: "ثبت آگهی",
    },
    {
      label: "آگهی های من",
      to: "/my-ads",
      icon: <MdLibraryAddCheck {...props} />,
      title: "آگهی های من",
    },
    {
      label: "آگهی های نشان شده",
      to: "/book-marks",
      icon: <IoBookmarks {...props} />,
      title: "آگهی های نشان شده",
    },
    {
      label: "پرداخت های من",
      to: "/my-payments",
      icon: <MdPayment {...props} />,
      title: "پرداخت های من",
    },
    {
      label: "خرید اشتراک",
      to: "/plans",
      icon: <RiVipCrownFill {...props} />,
      title: "خرید اشتراک",
    },
    {
      label: "پشتیبانی",
      to: "/support",
      icon: <BiSupport {...props} />,
      title: "پشتیبانی",
    },
  ];
  const render = () => {
    let res = "";
    links.map(link => {
      if (link.to == pathname) {
        res = link.title;
      }
    });
    return res;
  };
  return (
    <div className="container-fluid hv-100 main-panel">
      <div className="row">
        <div className=" d-none d-lg-flex col-lg-2 drawer p-0">
          <div className="logo">
            <Link to={"/"}>
              <img src={require("../Assets/images/logo.png")} />
            </Link>
          </div>
          <div className="links">
            <ul>
              {links.map(link => {
                return (
                  <li
                    className={`fs-14 fw-500 ${
                      pathname == link.to ? "link-active" : ""
                    }  `}
                  >
                    <Link to={link.to}>
                      {link.icon}
                      <span>{link.label}</span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="bottom-wrapper">
            <SupportCard />
            <a className="exit" onClick={logout}>
              <a className="fs-14 fw-500">
                <BiExit />
                <span>خروج از حساب</span>
              </a>
            </a>
          </div>
        </div>
        <div className="col-lg-10 col-12 main-content" style={{}}>
          <div className="content-panel">
            <div className="navbar-panel d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <button className="buger-btn d-none" onClick={toggle}>
                  <img src={require("../Assets/images/menu-burger.png")} />
                </button>
                <h1 className="fs-20 fw-500 m-0 ">{render()}</h1>
              </div>
              <div className="show-date">
                <p className="fs-14 fw-400">{now()}</p>
                <BsCalendar2CheckFill {...props} className="icon-color" />
              </div>
            </div>
            {children}
          </div>
        </div>
      </div>

      <Offcanvas placement="end" show={show} onHide={toggle}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <img
              src={require("../Assets/images/logo.png")}
              style={{
                width: "109.05px",
                height: "73.96px",
                objectFit: "contain",
              }}
            />
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="links">
            <ul>
              {links.map(link => {
                return (
                  <li
                    className={`fs-14 fw-500 ${
                      pathname == link.to ? "link-active" : ""
                    }  `}
                  >
                    <Link to={link.to}>
                      <img src={link.img} />
                      <span>{link.label}</span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="bottom-wrapper">
            <SupportCard />
            <a className="exit">
              <a className="fs-14 fw-500">
                <BiExit {...props} />
                <span>خروج از حساب</span>
              </a>
            </a>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default PanelLayout;
